import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Form } from "@grandvisionhq/forms";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useCCCAddressFormSlots } from "../../../../../../slots/slots/CCCAddressFormSlotsContext.js";
const DeliveryAddressForm = ({ cccForm, onChange, onSave, onCancel }) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const isLoading = cccForm?.saveFormCall.status === "loading";
  const isError = cccForm?.saveFormCall.status === "failed";
  const {
    Slots: { form: FormTemplate }
  } = useCCCAddressFormSlots();
  if (!FormTemplate) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "billingAddress",
      "data-t": "billingAddress",
      className: "ccc-deliveries__form",
      initialFormState: cccForm?.state,
      onChange: ({ formState }) => {
        onChange(formState);
      },
      onSubmit: ({ formState }) => {
        onSave(formState);
      }
    },
    isError && /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, getFormattedLabel("account.ccc.detail.saveFailed", { parseLink: true })),
    /* @__PURE__ */ React.createElement(FormTemplate, { addressType: "billingAddress" }),
    /* @__PURE__ */ React.createElement("p", { className: "ccc-deliveries__note" }, /* @__PURE__ */ React.createElement("strong", null, getLabel("account.common.pleaseNote"), ":"), " ", getLabel("account.ccc.detail.note")),
    /* @__PURE__ */ React.createElement("div", { className: "ccc-deliveries__button-block" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: getLabel("account.action.save"),
        className: "ccc-deliveries__button",
        isLoading,
        type: "submit",
        "data-t": "save-delivery-address"
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: getLabel("common.actions.cancel"),
        className: "ccc-deliveries__button",
        onClick: onCancel,
        variant: "outline"
      }
    ))
  );
};
export {
  DeliveryAddressForm,
  DeliveryAddressForm as default
};
//# sourceMappingURL=DeliveryAddressForm.js.map
